// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1OcEG","productName":"Table_productName__U7sS_"};